import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputPhoneField from '../../../components/form/InputPhoneField';
import InputField from '../../../components/form/InputField'; // import regular input
import SubmitButton from '../../../components/form/SubmitButton';
import LoadingButton from '../../../components/form/LoadingButton';
import { apiPost } from '../../../utils/api';
import { showError, showSuccess } from '../../../utils/alert';
import { Store } from '../../../types/modules/store.type';
import { useDispatch } from 'react-redux';
import { loginStore } from '../../../redux/storeSlice';
import { getdeviceId } from '../../../utils/auth';

interface LoginFormData {
  phone: string;
  password: string;
}

export default function StoreLogin() {
  const { t } = useTranslation();
  const { handleSubmit, register, formState: { errors } } = useForm<LoginFormData>();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();


  const onSubmit = async (data: LoginFormData) => {
    try {
      setLoading(true);
      const deviceId = getdeviceId();
      const response = await apiPost('store/login', {phone:`966${data.phone}`,password:data.password,deviceId}) as { accessToken: string, refreshToken: string, store:Store };
      showSuccess(t("signup_otp"));
      dispatch(loginStore({accessToken:response.accessToken,refreshToken:response.refreshToken,store:response.store}));
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      showError(err.message);
    }
  };

  return (
    <div className="min-h-screen w-screen flex flex-col md:flex-row bg-light overflow-hidden">
      {/* Image Section */}
      <div className="hidden md:block md:w-1/2 h-screen">
        <img
          src={"/main.png"}
          alt="Login"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Form Section */}
      <div className="flex flex-1 justify-center items-center p-8 md:p-16 min-h-screen">
        <div className="w-full max-w-md p-6 md:p-8">
          {/* Title */}
          <h1 className="text-2xl text-center font-bold text-Black mb-2">{t('login.title')}</h1>

          {/* Form */}
          <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4" dir={"ltr"}>
            <InputPhoneField
              placeholder={t('phonePlaceholder')}
              register={register('phone', { required: t('phoneRequired') })}
              error={errors.phone}
            />

            {/* Password Field */}
            <InputField
              placeholder={t('passwordPlaceholder')}
              type="password"
              register={register('password', { required: t('passwordRequired') })}
              error={errors.password}
            />

            {loading
              ? <LoadingButton height={64} />
              : <SubmitButton height={64} label={('login_btn')} />
            }
          </form>
        </div>
      </div>
    </div>
  );
}
